import { FC } from 'react';

import Typography from '@mui/material/Typography';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';

type CancelSubmitToFulfilmentDialogProps = {
  onClose: () => void;
  proceed: () => void;
};

const CancelSubmitToFulfilmentDialog: FC<
  CancelSubmitToFulfilmentDialogProps
> = ({ onClose, proceed }) => {
  return (
    <ModalNotification
      size='xs'
      fullWidth
      open
      onClose={onClose}
      dialogProps={{
        title: 'Cancel submit to fulfilment',
        content: (
          <Typography>
            Are you sure you want to cancel submit to fulfilment process?
          </Typography>
        ),
        actions: [
          {
            label: 'close',
            onClick: onClose,
          },
          {
            label: 'Cancel submission',
            color: 'error',
            variant: 'contained',
            onClick: proceed,
          },
        ],
      }}
    />
  );
};

export default CancelSubmitToFulfilmentDialog;
